import { useTranslation } from '@blocs.i18n';
import { SizesCategoryEnum } from '../types';

export const useSizesCategoryOptions = () => {
  const { t } = useTranslation();

  return [
    { value: SizesCategoryEnum.men, label: t('common:profile.sizes.men') },
    { value: SizesCategoryEnum.women, label: t('common:profile.sizes.women') },
    { value: SizesCategoryEnum.children, label: t('common:profile.sizes.children') },
  ];
};
